module.exports = __webpack_public_path__ + "534799e3843a57470903de678eb3e95a.jpg";